import { render, staticRenderFns } from "./ModalPendencias.vue?vue&type=template&id=13a88709"
import script from "./ModalPendencias.vue?vue&type=script&lang=ts"
export * from "./ModalPendencias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports